import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Locations', to: '/location' },
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-stone-200">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center shrink-0">
          <img
            src="https://storage.readdy-site.link/project_files/058bf520-f657-4c96-b118-7a4d18744205/4d9bb29b-3793-4492-b8d6-4116ced28368_polish-concrete.png?v=8f2e6b7e812c1f7d87b3da2c1fdb6bff"
            alt="Polished Concrete Plus"
            className="h-12 w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-xs uppercase tracking-[0.22em] transition-colors duration-300 whitespace-nowrap ${
                pathname === link.to
                  ? 'text-[#c8a951]'
                  : 'text-stone-600 hover:text-[#c8a951]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Right CTA */}
        <div className="hidden lg:flex items-center gap-6">
          <a
            href="tel:3204931454"
            className="text-[#c8a951] text-sm font-medium tracking-wide whitespace-nowrap hover:text-[#a88830] transition-colors"
          >
            320.493.1454
          </a>
          <a
            href="#contact"
            className="bg-[#c8a951] text-white text-xs font-bold px-6 py-3 uppercase tracking-[0.16em] hover:bg-[#a88830] transition-colors whitespace-nowrap cursor-pointer"
          >
            Get a Quote
          </a>
        </div>

        {/* Mobile menu toggle */}
        <button
          className="lg:hidden w-10 h-10 flex items-center justify-center text-stone-800 cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-stone-200 px-6 py-6 flex flex-col gap-5">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-sm uppercase tracking-[0.2em] text-stone-600 hover:text-[#c8a951] transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <a href="tel:3204931454" className="text-[#c8a951] text-sm font-medium mt-2">
            320.493.1454
          </a>
          <a
            href="#contact"
            className="bg-[#c8a951] text-white text-xs font-bold px-6 py-3 uppercase tracking-[0.16em] text-center"
          >
            Get a Quote
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
